// extracted by mini-css-extract-plugin
module.exports = {"all-columns":"Score_style_all-columns__3cB4X"};